import * as CoreFns from '../utilities/CoreFns';

export function getMessage(doingWhat, itemEdited, currentList, screenKeys, tabSelected, isShowingSomeDropDown, tgtDropDown){
      var msg = '';
      var highlightAnItem = '';

      if (doingWhat.v === 0){
        highlightAnItem = {t:'withinPage', v:'+ Panel'};
        msg = 'Welcome! Here is a simple tutorial to get you started. Add a panel by clicking the "+ Panel" button at the bottom of this page.'
      }else if (doingWhat.v === 1){
        msg = 'Add a Container to a Panel. ';
        if (itemEdited && itemEdited.t === 'screen'){
          if (tgtDropDown){
            highlightAnItem = {t:'leftPanel', v:'AddElement'};
            msg += ' Click on the "Add Item" tab on the left bar';
          }else if (tabSelected && tabSelected.t === 'AddElement'){
            highlightAnItem = {t:'addElement', v:'Container'};
            msg += ' Click on the "Container" component';
          }else{
            highlightAnItem = {t:'leftPanel', v:'AddElement'};
            msg += ' Click on the "Add Item" tab on the left bar';
          }
        }else{
          if (screenKeys.length > 0){
            if (tabSelected && tabSelected.t === 'Navigator'){
              highlightAnItem = {t:'navigator', v:'screen'};
              msg += 'Select a panel by selecting it in the navigator';
            }else{
              highlightAnItem = {t:'leftPanel', v:'Navigator'};
              msg += ' To select panel, click on the "Navigator" tab on the left bar';
            }
          }else{
            highlightAnItem = {t:'withinPage', v:'+ Panel'};
            msg = 'Add a panel by scrolling to the bottom of the page and clicking the "+ Panel" button.'
          }
        }
      }else if (doingWhat.v === 2){
        msg = 'Add a Row to the Container. ';
        if (itemEdited && itemEdited.t === 'item'){
          var thisItemType = CoreFns.goDownPath(currentList, itemEdited.path).t;
          if (thisItemType === 'CONTAINER'){
            if (tgtDropDown){
              highlightAnItem = {t:'leftPanel', v:'AddElement'};
              msg += ' Click on the "Add Item" tab on the left bar';
            }else if (tabSelected && tabSelected.t === 'AddElement'){
              highlightAnItem = {t:'addElement', v:'Row'};
              msg += ' Click on the "Row" component';
            }else{
              highlightAnItem = {t:'leftPanel', v:'AddElement'};
              msg += ' Click on the "Add Item" tab on the left bar';
            }
          }else if (thisItemType === 'HFLEX'){
            highlightAnItem = {t:'editorBar', v:'Amend Parent (Container)'};
            msg += ' Go to the parent container by clicking on the parent element.';
          }else{
            highlightAnItem = {t:'editorBar', v:'Amend Parent (Row)'};
            msg += ' Go to the parent row by clicking on the parent element.';
          }
        }else{
          msg += ' Select the container by clicking on it';
        }
      }else if (doingWhat.v === 3){
        msg = 'Add a Button to the Row. ';
        if (itemEdited && itemEdited.t === 'item'){
          var thisItemType1 = CoreFns.goDownPath(currentList, itemEdited.path).t;
          if (thisItemType1 === 'HFLEX'){
            if (tgtDropDown){
              highlightAnItem = {t:'leftPanel', v:'AddElement'};
              msg += ' Click on the "Add Item" tab on the left bar';
            }else if (tabSelected && tabSelected.t === 'AddElement'){
              highlightAnItem = {t:'addElement', v:'Button'};
              msg += ' Click on the "Button" component';
            }else{
              highlightAnItem = {t:'leftPanel', v:'AddElement'};
              msg += ' Click on the "Add Item" tab on the left bar';
            }
          }else if (thisItemType1 === 'CONTAINER'){
            msg += ' Select the row by clicking on it';
          }else if (isShowingSomeDropDown && isShowingSomeDropDown.t === 'ElementStyle'){
            highlightAnItem = {t:'editorBar', v:'Amend Parent (Row)'};
            msg += ' Go to the parent row by clicking on the parent element.';
          }else{;
            highlightAnItem = {t:'leftPanel', v:'ElementStyle'};
            msg += ' Clicking on the element tab to access options pertaining to this element.';
          }
        }else{
          msg += ' Select the row by clicking on it';
        }
      }else if (doingWhat.v === 4){
        msg = 'Change button color. ';
        if (itemEdited && itemEdited.t === 'item'){
          if (CoreFns.goDownPath(currentList, itemEdited.path).t === 'BUTTON'){
            if (tabSelected && tabSelected.t === 'ElementStyle'){
              if (tgtDropDown && tgtDropDown.t === 'Colors'){
                highlightAnItem = {t:'style', v:'buttonColor'};
                msg += 'Click one of the options under "Color"';
              }else{
                highlightAnItem = {t:'editorBar', v:'Colors'};
                msg += 'Select the "Colors" icon below'
              }
            }else{
              highlightAnItem = {t:'leftPanel', v:'ElementStyle'};
              msg += ' Clicking on the element tab to access options pertaining to this element.';
            }
          }else{
            msg += 'Select button by clicking on it';
          }
        }else{
          msg += 'Select button by clicking on it';
        }
      }else if (doingWhat.v === 5){
        msg = 'Add action when button is clicked. ';
        if (itemEdited && itemEdited.t === 'item' && (CoreFns.goDownPath(currentList, itemEdited.path).t === 'BUTTON')){
          if (tabSelected && tabSelected.t === 'ElementStyle'){
            if (tgtDropDown && tgtDropDown.t === 'On Click'){
              msg += 'Change "No Action" to something else';
              highlightAnItem = {t:'actions'};
            }else{
              highlightAnItem = {t:'editorBar', v:'On Click'};
              msg += 'Select the "On Click" icon on the editor bar'
            }
          }else{
            highlightAnItem = {t:'leftPanel', v:'ElementStyle'};
            msg += ' Clicking on the element tab to access options pertaining to this element.';
          }
        }else{
          msg += 'Select button by clicking on it';
        }

      }else if (doingWhat.v === 6){
        msg = 'Preview dApp by clicking on the "Launch" tab';
      }	

      return {message:msg, highlightAnItem};
}